<div class="min-h-screen flex">
    <!-- Lewa strona - Graficzna sekcja -->
    <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <!-- Zdjęcie w tle -->
        <img src="assets/images/auth-hero.jpg"
             alt=""
             class="absolute inset-0 w-full h-full object-cover object-center">

        <!-- Gradient overlay -->
        <div class="absolute inset-0 bg-gradient-to-br from-emerald-900/80 via-teal-800/70 to-cyan-900/80"></div>

        <!-- Dekoracyjne elementy -->
        <div class="absolute inset-0 pointer-events-none">
            <div class="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
            <div class="absolute bottom-0 left-0 w-80 h-80 bg-cyan-500/10 rounded-full -translate-x-1/3 translate-y-1/3 blur-3xl"></div>
        </div>

        <!-- Treść -->
        <div class="relative z-10 flex flex-col justify-between py-12 px-12 xl:px-20 text-white h-full">
            <div></div>

            <div class="max-w-lg">
                <h2 class="text-4xl xl:text-5xl font-bold mb-6 leading-tight">
                    Załóż konto<br>
                    <span class="text-emerald-200">w 26 sekund</span>
                </h2>

                <p class="text-lg text-white/80 mb-10">
                    Bez zbędnych formalności. Bez karty kredytowej.<br>Po prostu zacznij wystawiać faktury.
                </p>

                <!-- Korzyści -->
                <div class="space-y-3">
                    <div class="flex items-center gap-4 bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/10">
                        <div class="w-10 h-10 rounded-lg bg-emerald-500/30 flex items-center justify-center flex-shrink-0">
                            <mat-icon [svgIcon]="'tabler_outline:cloud'" class="!w-5 !h-5 text-emerald-300"></mat-icon>
                        </div>
                        <div>
                            <div class="font-semibold">Wszystko w chmurze</div>
                            <div class="text-sm text-white/70">Dostęp do faktur z każdego urządzenia</div>
                        </div>
                    </div>
                    <div class="flex items-center gap-4 bg-white/10 backdrop-blur-md rounded-xl p-4 border border-white/10">
                        <div class="w-10 h-10 rounded-lg bg-emerald-500/30 flex items-center justify-center flex-shrink-0">
                            <mat-icon [svgIcon]="'tabler_outline:building-bank'" class="!w-5 !h-5 text-emerald-300"></mat-icon>
                        </div>
                        <div>
                            <div class="font-semibold">Integracja z KSeF</div>
                            <div class="text-sm text-white/70">Wysyłaj faktury do KSeF jednym kliknięciem</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Trust signals na dole -->
            <div class="flex items-center gap-6">
                <div class="flex items-center gap-2 text-sm text-white/60">
                    <mat-icon [svgIcon]="'tabler_outline:shield-check'" class="!w-4 !h-4 text-green-400/80"></mat-icon>
                    <span>Bezpieczne dane</span>
                </div>
                <div class="flex items-center gap-2 text-sm text-white/60">
                    <mat-icon [svgIcon]="'tabler_outline:credit-card-off'" class="!w-4 !h-4 text-green-400/80"></mat-icon>
                    <span>Bez karty kredytowej</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Prawa strona - Formularz -->
    <div class="w-full lg:w-1/2 flex flex-col justify-center px-6 py-12 lg:px-16 xl:px-24 bg-white dark:bg-gray-900">
        <div class="max-w-md w-full mx-auto">
            <!-- Logo -->
            <div class="mb-8">
                <a routerLink="/" class="group inline-flex items-center gap-2.5">
                    <img class="h-8 w-8 rounded-lg object-contain transition-transform group-hover:scale-105" src="assets/images/logo-a.png" alt="Logo Fakturnia" width="32" height="32">
                    <span class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Fakturnia</span>
                </a>
            </div>

            <!-- Nagłówek -->
            <div class="mb-8">
                <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                    Utwórz konto 🚀
                </h1>
                <p class="text-gray-600 dark:text-gray-400">
                    Dołącz do Fakturni i zacznij oszczędzać czas
                </p>
            </div>

            <!-- Formularz rejestracji -->
            <register></register>

            <!-- Separator -->
            <div class="relative my-8">
                <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-200 dark:border-gray-700"></div>
                </div>
                <div class="relative flex justify-center text-sm">
                    <span class="px-4 bg-white dark:bg-gray-900 text-gray-500">Masz już konto?</span>
                </div>
            </div>

            <!-- Przycisk logowania -->
            <a routerLink="/logowanie" 
               class="w-full flex items-center justify-center gap-2 px-6 py-3 border-2 border-gray-200 dark:border-gray-700 rounded-xl font-semibold text-gray-700 dark:text-gray-300 hover:border-primary-500 hover:text-primary-600 dark:hover:text-primary-400 transition-all duration-200 group">
                <span>Zaloguj się</span>
                <mat-icon [svgIcon]="'tabler_outline:arrow-right'" class="!w-5 !h-5 transition-transform group-hover:translate-x-1"></mat-icon>
            </a>

            <!-- Separator -->
            <div class="relative my-8">
                <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-200 dark:border-gray-700"></div>
                </div>
                <div class="relative flex justify-center text-sm">
                    <span class="px-4 bg-white dark:bg-gray-900 text-gray-500">lub spróbuj z</span>
                </div>
            </div>

            <!-- Logowanie przez Google -->
            <log-in-with-google class="block w-full"></log-in-with-google>

            <!-- Logowanie przez Apple -->
            <log-in-with-apple class="block w-full mt-3"></log-in-with-apple>

            <!-- Trust badges mobile -->
            <div class="mt-8 lg:hidden">
                <div class="flex flex-wrap justify-center gap-4 text-sm text-gray-500 dark:text-gray-400">
                    <div class="flex items-center gap-1">
                        <mat-icon [svgIcon]="'tabler_outline:shield-check'" class="!w-4 !h-4 text-green-500"></mat-icon>
                        <span>Bezpieczne</span>
                    </div>
                    <div class="flex items-center gap-1">
                        <mat-icon [svgIcon]="'tabler_outline:credit-card-off'" class="!w-4 !h-4 text-green-500"></mat-icon>
                        <span>Bez karty</span>
                    </div>
                    <div class="flex items-center gap-1">
                        <mat-icon [svgIcon]="'tabler_outline:clock'" class="!w-4 !h-4 text-green-500"></mat-icon>
                        <span>30 sekund</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
